export type LabelPrintRotation = 0 | 90 | 180 | 270;

export const LABEL_PRINT_ROTATIONS: LabelPrintRotation[] = [0, 90, 180, 270];

export function isLabelPrintRotation(value: number): value is LabelPrintRotation {
  return value === 0 || value === 90 || value === 180 || value === 270;
}

export function rotateLabelClockwise(rotation: LabelPrintRotation): LabelPrintRotation {
  return ((rotation + 90) % 360) as LabelPrintRotation;
}

export function rotateLabelCounterClockwise(rotation: LabelPrintRotation): LabelPrintRotation {
  return ((rotation + 270) % 360) as LabelPrintRotation;
}
